module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeweb"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "swiper"
  }, [_c('SwiperList', {
    attrs: {
      "swiperList": _vm.swiperList
    }
  })], 1)]), _vm._v(" "), (_vm.sysparam) ? _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('template-a')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-7dfce6f4!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/WebHome.vue
// module id = 302
// module chunks = 0